module.exports = __webpack_public_path__ + "img/kenyamap.fb777ded.png";